import { render } from "./page_3.vue?vue&type=template&id=7cf2aa05"
import script from "./page_3.vue?vue&type=script&lang=js"
export * from "./page_3.vue?vue&type=script&lang=js"

import exportComponent from "/Users/felipewalflan/Documents/Gitlab gen-t/_front/base-questionnaire/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__